import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  width: 100vw;
  min-height: 85vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  .navbar {
    width: 90%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    height: fit-content;
    flex-wrap: wrap;
    .navbar-content {
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex-basis: 50%;
      height: fit-content;
      h3 {
        font-weight: 700;
        padding-right: 0.5rem;
        margin-bottom: 0;
      }
      p {
        margin: 0;
      }
      select {
        margin: 1rem 0;
        border: 1px solid #ccc;
        width: 70%;
        color: #333;
        border-radius: 4px;
        font-size: 0.8em;
        height: 36px;
        border-radius: 1.5rem;
        -webkit-appearance: none;
      }
      #phase-select {
        -webkit-appearance: none;
        border: 1px solid #ccc;
        color: #333;
        font-size: 1em;
        width: fit-content;
      }
      .season-container {
        width: 120px;
        position: relative;
        #date-pop-up {
          display: none;
          position: fixed;
          background: #fff;
          width: 80vw;
          height: 40vh;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border: 1px solid black;
          z-index: 100;
          &.active {
            display: block;
          }
        }
        #season-select {
          display: flex;
          align-items: center;
          padding-left: 0.5rem;
        }
      }
    }
  }
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin-bottom: 2rem;
    .stat-container {
      height: 40vh;
      padding: 1rem;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      max-width: 90%;
      width: 90%;
      box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
    }
  }
  .radar-chart_container {
    width: 90%;
    margin: 1rem auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .radar-chart {
      width: calc(100% - 1rem);
      padding: 0;
      box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
      padding: 0.5rem;
      border-radius: 24px;
      min-height: 0;
      select,
      .season-container {
        width: 40%;
      }
    }
  }

  .line-chart-stats {
    width: 90%;
    display: flex;
    flex-direction: row;
    margin: 1rem auto;
    justify-content: space-between;
    .line-chart {
      width: calc(100%);
      background: #fff;
      box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
      border-radius: 24px;
      padding: 0.5rem;
      .header {
        display: flex;
        flex-direction: column;
        select {
          -webkit-appearance: none;
          border: 1px solid #ccc;
          color: #333;
          font-size: 1em;
          width: fit-content;
          height: 36px;
          border-radius: 1.5rem;
          margin-top: 1rem;
        }
      }
      .chart-container {
        height: auto;
      }
    }
  }
  .percentile-chart-container {
    width: 90%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 3rem;
    flex-wrap: wrap;
    gap: 1rem;
    .percentile-chart-container-extra {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      width: 100%;
      padding: 1rem;
      border-radius: 24px;
      box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
      h3 {
        margin: 0;
      }
      .percentile-chart-content {
        display: flex;
        width: 100%;
        .percentile-chart-text {
          width: 50%;
          display: flex;
          flex-direction: column;
          .value-container {
            border-top: 3px solid #eee;
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: space-between;
            .value-content {
              display: flex;
              height: 100%;
              .title {
                border: 1px solid #cccccc;
                width: 70%;
                margin: 0;
              }
              .value {
                width: 30%;
                margin: 0;
                border: 1px solid #cccccc;
              }
            }
          }
        }
      }
    }
  }
  @media only screen and (min-width: 867px) {
    .navbar {
      justify-content: flex-start;
      height: 10vh;
      .navbar-content {
        flex-direction: row;
        align-items: center;
        flex-basis: fit-content;
        padding: 0 1rem;
        h3 {
          margin-bottom: 18.72px;
        }
        select {
          font-size: 1em;
        }
        .season-container {
          #date-pop-up {
            width: 400px;
            height: 400px;
          }
        }
      }
    }
    .container {
      flex-direction: row;
      .stat-container {
        max-width: 60%;
        width: 60%;
      }
    }
    .radar-chart_container {
      flex-direction: row;
      .radar-chart {
        width: calc(60% + 1rem);
      }
    }
    .line-chart-stats {
      .line-chart {
        .header {
          flex-direction: row;
          select {
            margin-top: 0;
            margin-right: 1rem;
          }
        }
      }
    }
    .percentile-chart-container .percentile-chart-container-extra {
      width: 45%;
    }
  }
`;

export const UpgradeContainer = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 85vh;
  width: 100%;
  h2,
  p {
    width: 80%;
    margin: 1rem auto;
    text-align: center;
  }
  form {
    width: 90vw;
    .form-group {
      display: flex;
      flex-direction: column;
      input {
        padding: 1rem;
        margin: 1rem 0;
        border-radius: 14px;
        border: 1px solid #cccccc;
      }
    }
    .personal-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      .buyer-name {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .messagge input {
        height: 100px;
      }
    }
  }
  .btns-container {
    display: flex;
    margin: 1rem auto;
  }
`;
